import React from 'react'
import PropTypes from 'prop-types'

export default class PackageGroup extends React.Component {
  render() {
    const { children, eventCategory, packageGroup } = this.props

    return (
      <div className="package-group">
        <div className="package-subtitle">{ eventCategory.attributes.name }: { packageGroup.attributes.name }</div>
        <div>
          { children }
        </div>
      </div>
    )
  }
}
